;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import { Block } from 'app/templates/renderBlocks';

import { sharpnessStoryFragment } from 'components/blocks/BlockSharpnessStory';

import {
    assetFragment,
    ctaFragment,
    iconFragment,
    linkFragment,
} from 'lib/graphql/fragments';

import BlockProductSharpnessStory from './BlockProductSharpnessStory';

const query = /* GraphQL */ `
    ${assetFragment}
    ${ctaFragment}
    ${linkFragment}
    ${iconFragment}
    ${sharpnessStoryFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockProductSharpnessStory(preview: $preview, id: $id) {
            sharpnessStoryItem {
                product
                image {
                    ...Asset
                }
                headline
                copy {
                    json
                }
                detailCopy {
                    json
                }
                backgroundColor
                vintageYear
                agedUnit
                agedTime
                flavorProfileData
                cta {
                    ...CTA
                }
            }
            sharpnessStory {
                ...SharpnessStoryFragment
            }
            sharpnessStoryPage {
                slug
            }
            backgroundColor
            icon {
                ... on Icon {
                    ...Icon
                }
            }
            eyebrow
            headline {
                json
            }
            copy {
                json
            }
            ctaText
            flushBottom
            flushTop
            anchorId
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockProductSharpnessStory },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });
    return blockProductSharpnessStory;
}

const BlockProductSharpnessStoryServer = async ({ id }) => {
    const block = await fetchBlock(id);
    return (
        <BlockProductSharpnessStory
            {...block}
            masthead={
                block?.sharpnessStory?.masthead && (
                    <Block
                        id={block?.sharpnessStory.masthead.sys.id}
                        type="BlockFullWidthMedia"
                        theme="Sharpness Story"
                    />
                )
            }
        />
    );
};

export default BlockProductSharpnessStoryServer;
